import {LatLng} from "../views/map";

function googleMapDirectionsUrl(location: LatLng) : string {
    return destinationToGoogleMapDirectionsUrl(location.lat + "," + location.lng);
}

export function destinationToGoogleMapDirectionsUrl(destination: string) : string {

    const params : any = {
        destination: destination,
        travelmodel: "driving",
    };

    const p = Object.keys(params).map((key) => {
        return key + "=" + encodeURIComponent(params[key]);
    }).join("&");

    const out = "https://www.google.com/maps/dir/?api=1&" + p;
    return out;
}
